import { Button, Modal, Typography } from '@volvo/vcdk-react';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { IIndividualProduct } from '@/service/vpc/types/IIndividualProducts';

import ProductType from '@/routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/specifications/_components/ProductType';
import { manualsAndHandbooksBaseLink } from '@/utils/baseLinks';

type ProductEntry = {
  serialNumber: string;
  productDesignation: string;
};

type GroupedProducts = Record<string, ProductEntry[]>;

type Props = {
  open: boolean;
  onClose: () => void;
  products: IIndividualProduct[];
};

const ManualsSelectionModal: React.FC<Props> = ({ open, onClose, products }) => {
  const { t } = useTranslation();

  const groupedProducts = useMemo(() => {
    const groups: GroupedProducts = {};

    for (const product of products) {
      const category = product.productCategory;
      if (!groups[category]) {
        groups[category] = [];
      }
      const existing = groups[category].find((p) => p.productDesignation === product.productDesignation);
      if (!existing) {
        groups[category].push({
          serialNumber: product.serialNumber,
          productDesignation: product.productDesignation,
        });
      }
    }

    return groups;
  }, [products]);

  return (
    <Modal width={680} open={open} onClose={onClose}>
      <span slot="header">{t(($) => $.pages.unit.tabs.manuals_handbooks)}</span>
      <Typography>{t(($) => $.pages.unit.manuals_selection_description)}</Typography>
      <div className="flex flex-col gap-6 py-8 md:flex-row md:justify-between">
        {Object.entries(groupedProducts).map(([category, entries]) => (
          <div key={category} className="flex flex-col gap-4">
            <ProductType type={category} />
            {entries.map(({ productDesignation, serialNumber }) => (
              <Button
                key={productDesignation}
                variant="secondary"
                href={`${manualsAndHandbooksBaseLink}${serialNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                iconEnd="arrow-right"
              >
                {productDesignation}
              </Button>
            ))}
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default ManualsSelectionModal;
